import { Input, Directive } from '@angular/core';

/**
 * Renseigne la clé à utiliser pour construire la traduction
 * pour les messages d'erreur dans FormErrorMessageDirective.
 *
 * Exemple:
 *
 * ```html
 * <form dsdExtFormErrorValidationContext="capacite.erreurs">
 *
 * <form>
 *
 * <form dsdExtFormErrorValidationContext="preautorisation-en-ligne.erreurs">
 *
 * <form>
 * ```
 **/
@Directive({
  selector: '[dsdExtFormErrorValidationContext]',
  standalone: false
})
export class FormErrorValidationContextDirective {
  @Input('dsdExtFormErrorValidationContext')
  context: string;
}
